<template lang="pug">
.booking-card-overview(data-test-id="slidein-overview-wrapper")
  OverviewHeader(
    :headerData="headerData"
    :booking="bookingDetailsData"
    )
  OverviewDetails(
    :booking="bookingDetailsData"
    :customerName="customerName"
    :company="company"
    )
  OverviewProgram(
    :scheduledProducts="scheduledProducts"
    :activeBookingProduct="getActiveBookingProduct"
    :note="note"
    :nonScheduledProductsCount="nonScheduledProductsCount"
    :companyLength="company.length"
    :checkInTime="checkInTime"
    :endTime="endTime"
    )
  OverviewNonScheduledProducts(
    :nonScheduledProducts="nonScheduledProducts"
  )
  OverviewNote(
    :note="note"
    )
</template>

<script>
import OverviewHeader from './OverviewHeader.vue'
import OverviewDetails from './OverviewDetails.vue'
import OverviewProgram from './OverviewProgram.vue'
import OverviewNonScheduledProducts from './OverviewNonScheduledProducts.vue'
import OverviewNote from './OverviewNote.vue'
import { mapGetters } from 'vuex'

export default {
  name: 'OverviewWrapper',
  components: {
    OverviewHeader,
    OverviewDetails,
    OverviewProgram,
    OverviewNonScheduledProducts,
    OverviewNote,
  },
  props: {
    bookingDetails: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('planboardModule', ['getActiveBooking', 'getActiveBookingProduct']),
    note() {
      return this.bookingDetails?.Remarks[0]?.Remark || ''
    },
    nonScheduledProducts() {
      return (
        this.bookingDetails?.BookingProducts?.filter(
          product => product.FromDateTime == null && product.ToDateTime == null,
        ) || []
      )
    },
    scheduledProducts() {
      return (
        this.bookingDetails?.BookingProducts?.filter(
          product => product.FromDateTime != null && product.ToDateTime != null,
        ).sort((a, b) =>
          a.FromDateTime.localeCompare(b.FromDateTime),
        ) || []
      )
    },
    nonScheduledProductsCount() {
      return this.nonScheduledProducts?.length
    },
    checkInTime() {
      return this.bookingDetails?.Booking.PlannedCheckinTime
    },
    endTime() {
      return this.bookingDetails?.Booking.EndTime
    },
    headerData() {
      return this.scheduledProducts?.find(product => product.Key === this.getActiveBookingProduct)
    },
    bookingDetailsData() {
      return this.bookingDetails?.Booking
    },
    customerName() {
      return this.bookingDetails?.Customers[0]?.FullName || ''
    },
    company() {
      return this.bookingDetails?.Customers[0]?.CompanyName || ''
    },
  },
}
</script>

<style lang="stylus">
.booking-card-overview
  padding 15px

  p
    font-size 16px
    line-height 24px
    font-weight 400
    color #000E28 // black1

  .section-title
    font-weight 500
    margin-bottom 10px

  .details, .program, .non-scheduled-products, .note
    .panel
      background #F7F9FC
      border-radius 5px
      padding 15px
      margin-bottom 12px

      .text-ellipsis
        overflow hidden
        white-space nowrap
        text-overflow ellipsis
        padding-right 15px

      .square
        background #4E5A6A
        border-radius 2px
        color #FFF
        font-size 13px
        line-height 16px
        margin-right 10px
        padding 1px 4px

    .panel.empty
      max-height 45px
      overflow-y hidden
      display flex
      justify-content center
      align-items center

      p
        color #96999D

  ::-webkit-scrollbar
    width 4px

  ::-webkit-scrollbar-thumb
    background #E2E2E2
    border-radius 8px
</style>
